import React,{useEffect, useState} from "react";

import {ReactComponent as IconPrevEnd} from '../../../../assets/icons/ic-arrow-left-tripple.svg';
import {ReactComponent as IconPrev} from '../../../../assets/icons/ic-arrow-prev.svg';
import {ReactComponent as IconNext} from '../../../../assets/icons/ic-arrow-next.svg';
import {ReactComponent as IconNextEnd} from '../../../../assets/icons/ic-arrow-right-tripple.svg';

const Paging = ({currentPage = 1,goToPage,totalPages = 50, visibleCount = 10}) => {  
    const [pageNumbers, setPageNumbers] = useState([]);
    // 페이지 범위 계산
    const getPageRange = () => {
        let start = Math.max(1, currentPage - Math.floor(visibleCount / 2));
        let end = start + visibleCount - 1;

        // 끝이 totalPages를 넘으면 조정
        if (end > totalPages) {
        end = totalPages;
        start = Math.max(1, end - visibleCount + 1);
        }

        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    };

    useEffect(() => {
        setPageNumbers(getPageRange());
    },[currentPage, totalPages, visibleCount]);

    return (
        <div className="flex items-center justify-center gap-[8px] py-2 px-4 rounded text-white">
            <span
                className="cursor-pointer hover:text-gray-400 px-[5px] py-[8px]"
                onClick={() => goToPage(1)}
            >
                <IconPrevEnd />
            </span>
            <span
                className="cursor-pointer hover:text-gray-400 px-[5px] py-[8px]"
                onClick={() => goToPage(currentPage - 1)}
            >
                <IconPrev />
            </span>
            <div className="flex items-center gap-[8px]">
                {pageNumbers.map((page) => (
                    <span
                        key={page}
                        className={`cursor-pointer rounded flex items-center justify-center w-[32px] h-[32px] text-center
                                ${
                                    page === currentPage
                                        ? "bg-white text-black font-bold"
                                        : "hover:text-gray-300"
                                }`}
                        onClick={() => goToPage(page)}
                    >
                        {page}
                    </span>
                ))}
            </div>

            <span
                className="cursor-pointer hover:text-gray-400 px-[5px] py-[8px]"
                onClick={() => goToPage(currentPage + 1)}
            >
                <IconNext />
            </span>
            <span
                className="cursor-pointer hover:text-gray-400 px-[5px] py-[8px]"
                onClick={() => goToPage(totalPages)}
            >
                <IconNextEnd />
            </span>
        </div>
    );
};

export default Paging;
